<script setup lang="ts">
import { computed } from "vue";
import { RouterLink, useRouter } from "vue-router";

import { useArticleTabs } from "@/common/composables/use-article-tab";
import type { ArticleTab } from "@/types/search";

const props = defineProps<{
  hasTranslations: boolean;
  hasCombinations: boolean;
  hasSynonyms: boolean;
}>();

const router = useRouter();
const { articleTabRoute } = useArticleTabs(router);

interface Link {
  name: string;
  to: ArticleTab;
}

const links = computed<Link[]>(() => {
  const links: Link[] = [];

  if (props.hasTranslations) {
    links.push({ name: "oversættelser", to: "translations" });
  }

  if (props.hasCombinations) {
    links.push({ name: "kombinationer", to: "combinations" });
  }

  if (props.hasSynonyms) {
    links.push({ name: "synonymer", to: "synonyms" });
  }

  return links;
});

const isLastLink = (link: Link) => link === links.value[links.value.length - 1];
</script>

<template>
  <div class="article-content-empty">
    <RouterLink
      v-if="links.length === 1"
      :to="articleTabRoute(links[0].to)"
      class="article-content-empty__link"
    >
      Se {{ links[0].name }}
    </RouterLink>

    <template v-if="links.length === 2">
      Se
      <span v-for="link in links" :key="link.to">
        <RouterLink :to="articleTabRoute(link.to)" class="article-content-empty__link">
          {{ link.name }}
        </RouterLink>
        <span v-if="!isLastLink(link)"> eller </span>
      </span>
    </template>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.article-content-empty {
  &__link {
    color: rgb(@theme-colors[@primary][base]);
    text-decoration: underline;
  }
}
</style>
